





















// vendor
import { defineComponent, PropType, computed, ref } from "@vue/composition-api";
// local
import { FormItem, Checkboxes, DataChannel } from "../../ts/types";
import ErrorOverlay from "./error-overlay.vue";
import ErrorBox from "./error-box.vue";

export default defineComponent({

	emits:[ "input" ],
	props:{
		value:{
			type:Array as PropType<number[]>
		},
		config:{
			type:Object as PropType<FormItem<Checkboxes>>,
			required:true
		}
	},
	components:{
		ErrorOverlay,
		ErrorBox
	},
	setup(props, context){

		const pristine = ref(true);

		const val = computed({
			get:() => props.value,
			set:v => context.emit("input", v)
		});

		const state = computed(() => val.value && val.value.length > 0);

		const isValid = () => {
			pristine.value = false;
			return state.value;
		};

		const getChannels = (prefix:string):DataChannel<number>[] => {
			const v = val.value;
			if(!v){ return []; }
			return props.config.settings.options.map((option, index) => {
				const toggled = v.findIndex(v => v === index) > -1;
				return {
					key: `${prefix}/${index}`,
					data: toggled ? 1 : 0
				};
			});
		};

		const displayOptions = computed(() => {
			return props.config.settings.options.map((o, i) => {
				return {
					value: i,
					text: o
				}
			});
		});

		const init = () => {
			if(!val.value){ val.value = []; }
		};

		init();

		return {
			pristine,
			state,
			val,
			displayOptions,
			isValid,
			getChannels
		};
	}
});
